export { default, UserProfileTabs } from './UserProfileTabs';
export { useUserProfileTabs } from './useUserProfileTabs';
export type { UserProfileTabsProps, IUserProfileTabItem } from './types';
